import React from 'react'
import styled from '@emotion/styled'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import ContentfulImage from 'experiences/shared/ContentfulImage'
import { Container } from 'shared/layout/Container'
import { calcMultiplier, sortPartners, truncArray } from 'lib'
import { colors, mediaQueriesByDevice } from 'parameters/index'
import { View } from 'reshaped/bundle'

interface Props {
	partners: Partner[]
}

export const FeaturedPartners: React.FC<React.PropsWithChildren<Props>> = ({ partners }: Props) => (
	<FeaturedPartnersWrapper>
		<Container>
			<View paddingBlock={5}>
				<FeaturedPartnersGrid>
					<FeaturedPartnersTitle>Our Partner Network</FeaturedPartnersTitle>
					{truncArray(partners.sort(sortPartners), 5).map(partner => (
						<FeaturedPartnerItem key={partner.id}>
							<ContentfulImage
								layout={'fixed'}
								width={calcMultiplier(partner.logo, 120)}
								quality={40}
								asset={partner.logo}
							/>
						</FeaturedPartnerItem>
					))}
				</FeaturedPartnersGrid>
			</View>
		</Container>
	</FeaturedPartnersWrapper>
)

const FeaturedPartnersGrid = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: nowrap;

	${mediaQueriesByDevice.tablet} {
		flex-wrap: wrap;
		justify-content: center;
	}
`

const FeaturedPartnersWrapper = styled.div`
	background: ${colors.primaryLightGrey1};
	padding-top: 100px;

	${mediaQueriesByDevice.tablet} {
		padding-top: 300px;
	}
`

const FeaturedPartnerItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		filter: grayscale(100%);
		opacity: 0.5;
	}

	${mediaQueriesByDevice.tablet} {
		padding: 20px;
		flex: 1;
	}
`

const FeaturedPartnersTitle = styled.div`
	font-weight: bold;
	font-size: 18px;
	align-self: center;
	line-height: 140%;
	color: ${colors.secondaryDarkGrey1};

	${mediaQueriesByDevice.tablet} {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		max-width: unset;
		padding: 0 20px;
		margin-bottom: 16px;
	}
`
